import React from 'react'

function YContactPageLeft() {
    return (
        <>
            <div className='contactPageLeft'>
                <h2>Welcome to Dehleze</h2>
                <p>Dehleze is a modern online shopping platform offering a wide range of fashion, lifestyle, and household products at affordable prices. With a focus on quality, customer satisfaction, and fast delivery, Dehleze brings a seamless and secure shopping experience to your fingertips. Whether you're looking for daily essentials or the latest trends, Dehleze is your one-stop destination for convenience and value.</p>
                <div className='YglobalFlex contactPageLeftDetailsFlex'>
                    <div className='YglobalFlex contactPageLeftDetails'>
                        <i className="fa-solid fa-location-dot"></i>
                        <p>123 Suspendis matis, Sollicitudin District,Accums Fringilla</p>
                    </div>
                    <div className='YglobalFlex contactPageLeftDetails'>
                        <i className="fa-regular fa-envelope"></i>
                        <p>Email: support@domainstore.com</p>
                    </div>
                    <div className='YglobalFlex contactPageLeftDetails'>
                        <i class="fa-solid fa-phone"></i>
                        <p>Hotline: 0123456789</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default YContactPageLeft